module.exports = __webpack_public_path__ + "static/media/logo2.aa1ebd50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo2.png
// module id = 154
// module chunks = 0